import { useMutation } from '@tanstack/react-query';
import * as Yup from 'yup';
import { AssetTypeEnum } from '@api/enum';
import { IAssetPurchaseOrder } from '@api/models';
import { updateAssetPurchaseOrder } from '@api/services/asset-purchaase-order.service';
// import { updateAssetPurchaseOrder } from '@api/services/asset-purchase-order.service';

export const useAssetPurchaseOrderUpdateForm = (
    clientInstallationId: string,
    projectInstallationId: string,
    initialData: IAssetPurchaseOrder
) => {
    const schema = Yup.object({
        remarks: Yup.string().required('Remarks are required'),
        typeOfAssets: Yup.mixed<AssetTypeEnum>()
            .oneOf([...Object.values(AssetTypeEnum), null])
            .nullable(),
    });

    const initialValues = {
        remarks: initialData?.remarks || '',
        typeOfAssets: initialData?.typeOfAssets || null,
        quantity: initialData?.quantity || null,
    };

    const mutation = useMutation((payload: typeof initialValues) =>
        updateAssetPurchaseOrder(clientInstallationId, projectInstallationId, initialData._id, payload)
    );

    const submit = async (values: typeof initialValues) => {
        const data = await mutation.mutateAsync(values);
        return data;
    };

    return {
        initialValues,
        schema,
        isSubmitting: mutation.isLoading,
        submit,
    };
};
